function shouldKeepNativePlaceholder(element: HTMLInputElement | HTMLTextAreaElement): boolean {
  if (element instanceof HTMLTextAreaElement) return false;
  return ['date', 'file', 'checkbox', 'radio', 'hidden'].includes(element.type);
}

/**
 * Imported PDF fields can carry verbose labels in several places. The PDF
 * matrix already supplies row and column headings, so Work Experience,
 * Education and Skills cells must not repeat the complete schema field label.
 * Keep all field metadata for submission while matching the concise Statvara
 * PDF preview.
 */
export function normalisePublishedPdfPlaceholders(root: HTMLElement): void {
  const form = root.querySelector<HTMLFormElement>('#applyForm');
  if (!form?.classList.contains('dynamic-application-paper-pdf')) return;

  form.querySelectorAll<HTMLElement>('.dynamic-pdf-layout .dynamic-field-description')
    .forEach((element) => element.remove());

  form.querySelectorAll<HTMLElement>([
    '.dynamic-pdf-matrix td > .dynamic-pdf-cell-label',
    '.dynamic-pdf-education td > .dynamic-pdf-cell-label',
    '.dynamic-pdf-skills td > .dynamic-pdf-cell-label',
  ].join(', ')).forEach((element) => element.remove());

  form.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(
    '.dynamic-pdf-layout input, .dynamic-pdf-layout textarea',
  ).forEach((element) => {
    if (shouldKeepNativePlaceholder(element)) return;
    element.removeAttribute('title');
    element.placeholder = element instanceof HTMLTextAreaElement ? 'Enter details' : 'Enter response';
  });
}
